"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WechatAppletsLoginWithMobileRequest = void 0;
var WechatAppletsLoginWithMobileRequest = /** @class */ (function () {
    function WechatAppletsLoginWithMobileRequest() {
    }
    return WechatAppletsLoginWithMobileRequest;
}());
exports.WechatAppletsLoginWithMobileRequest = WechatAppletsLoginWithMobileRequest;
;
//# sourceMappingURL=wechatAppletsLoginWithMobile.request.js.map